<div class="row">
  <div class="small-12 columns">
    <h1>{{ 'creditAnnouncements.general.title' | translate }}</h1>
    <px-credit-announcements [prepaidNumber]="prepaidNumber"></px-credit-announcements>
    <a class="rs-btn" href="javascript: void(0);" (click)="navigateBack()">
      <i class="icon-Arrow-left rs-margin-right1"></i>
      {{ 'creditAnnouncements.general.back' | translate }}
    </a>
  </div>
</div>
